/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import ClearIcon from "@mui/icons-material/Clear";
import React from "react";
import styles from "./AppliedFilter.styles";

function AppliedFilter({ filter, onRemove }) {
  return (
    <div
      style={{
        ...styles.container,
        // ...(filter.disabled ? styles.disabled : {}),
      }}
    >
      <div style={styles.left}>
        <div style={styles.label}>{filter?.displayName}</div>
        <div style={styles.value}>{filter?.value}</div>
      </div>
      <div style={styles.right}>
        {!filter?.disabled && (
          <ClearIcon
            style={styles?.Icon}
            onClick={() => onRemove(filter?.key)}
          />
        )}
      </div>
    </div>
  );
}

export default AppliedFilter;
